import React from 'react';
import '../assets/sidebar.scss';
import info_icon from 'src/images/icon/info_icon.png';
import dma_icon from 'src/images/icon/dma_icon.png';
import verified_icon from 'src/images/icon/verified_icon.png';

const Sidebar: React.FC = () => {
    return (
        <div className="sidebar">
            <div className="dealership-sidebar-box">
                <div className="box-header">What you need</div>
                <div className="document-list">
                    <div className="list-item">
                        <img className="info-icon" src={info_icon} alt="Info" />
                        Dealership software info
                    </div>
                    <div className="list-item">
                        <img className="verified-icon" src={verified_icon} alt="Verified" />
                        DMV license Information
                    </div>
                </div>
                
                <div className="box-header">Sign contracts with our partners</div>
                <div className="subsection">
                    <div className="subsection-header">A2Z Sync</div>
                    <p>We partnered with A2Z Sync to integrate your inventory and process orders with your dealership software.</p>
                </div>

                <div className="subsection">
                    <div className="subsection-header">Safe-Guard</div>
                    <p>Our service and protection products are provided and managed by Safe-Guard. That way, you can earn more money for every order you get through Amazon Autos.</p>
                </div>
            </div>

        </div>
    );
};

export default Sidebar;